
export class MetricConfiguration {
duration: string;
endDate: string;
startDate: string;
}

